module.exports = __webpack_public_path__ + "img/purpose_1.e7439754.png";